import { DOMHelper } from "./helpers/dom-helper";
import { EventType } from "./constants/event-type-constants";
import { ObjectConstants, Selector } from "./constants/closing-without-lp";


export class ClosingWithoutLp {

  accordionList: Array<Element> = [];

  init() {
    this.prepareAccordionHeaders();
    this.toggleAccordionEvents();
  }

  prepareAccordionHeaders() {
    this.accordionList = DOMHelper.querySelectorAsArray(Selector.accordionHeader);
  }

  toggleAccordionEvents() {
    this.accordionList.forEach((header) => {
      header.addEventListener(EventType.CLICK, () => {
        this.toggleAccordion(header);
      });
    });
  }

  toggleAccordion(header: Element) {
    const accordionContent = header.nextElementSibling;
    accordionContent?.classList.toggle(ObjectConstants.active);
    header.querySelector(Selector.accordionArrow)?.classList.toggle(ObjectConstants.active);
  }
}
